import { toast } from 'react-toastify';

export const copyToClipboard = (text, title) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(title);
    })
    .catch((err) => {
      toast.error('Не вдалося скопіювати текст');
      console.log(err);
    });
};
